import { Routes } from '@angular/router';
import { EditFonctionComponent } from './edit-fonction/edit-fonction.component';
import { ListeFonctionsComponent } from './liste-fonctions/liste-fonctions.component';

export const FONCTIONS_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const FONCTIONS_ROUTES: Routes = [
    { path: '', component: ListeFonctionsComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditFonctionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditFonctionComponent, data: { roles: ['ORGANISME'] } }
];
